import Article from './Article';
import { ArticleQuery } from './ArticleQuery.graphql';

Article.query = ArticleQuery;

export default Article;
